// ignore-string-externalization

import React from 'react';
import Blog from '../../legacy/blog/Blog';
import BlogCategory from '../../legacy/blog/category/BlogCategory';
import { loadBlog } from '../../legacy/shared/store/blog';

// Legacy blog catergory page (/blog/category/some-section)

const BlogPage = ({ preview }: $TSFixMe) => {
  return (
    <Blog>
      <BlogCategory preview={preview} />
    </Blog>
  );
};

BlogPage.getInitialProps = async ({
  store,
  smartlingLanguage,
  preview,
}: $TSFixMe) => {
  return store
    .dispatch(
      loadBlog({ category: 'all', smartlingLanguage, preview } as $TSFixMe),
    )
    .then(() => {
      return { loaded: true, preview };
    });
};

export default BlogPage;
